import { render, staticRenderFns } from "./FeatureDisambiguationMenu.vue?vue&type=template&id=1bff6ee6&scoped=true"
import script from "./FeatureDisambiguationMenu.vue?vue&type=script&lang=ts"
export * from "./FeatureDisambiguationMenu.vue?vue&type=script&lang=ts"
import style0 from "./FeatureDisambiguationMenu.vue?vue&type=style&index=0&id=1bff6ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff6ee6",
  null
  
)

export default component.exports